import IMask from "imask";
import { z } from "zod";
import { MEMBERSHIP_NUMBER_FIELD_LENGTH } from "./constants.js";
const membershipNumberRegex = new RegExp(
  `^[0-9]{${MEMBERSHIP_NUMBER_FIELD_LENGTH}}$`
);
const usInputMask = IMask.createMask({
  mask: "00000",
  maxCharacterLimit: 5
});
const caInputMask = IMask.createMask({
  mask: "a0a 0a0",
  maxCharacterLimit: 7
});
const compactFormValidationSchema = z.object({
  emailAddress: z.string().email(),
  isFailure: z.boolean(),
  isSuccessful: z.boolean()
});
const standardBCFormValidationSchema = compactFormValidationSchema.extend({
  membershipNumber: z.string().optional().refine((val) => {
    if (typeof val !== "string") return false;
    if (!val || val.length === 0) return true;
    return membershipNumberRegex.test(val);
  })
});
const standardBDFormValidationSchema = compactFormValidationSchema.extend({
  zipCode: z.string().regex(/^(?:(\d{5})|([A-Z]\d[A-Z] \d[A-Z]\d))$/gi)
});
const getErrorAriaIconAttributes = (errorAriaLabelPrefix) => ({
  "aria-hidden": false,
  "aria-label": `${errorAriaLabelPrefix}: `,
  focusable: true
});
export {
  caInputMask,
  compactFormValidationSchema,
  getErrorAriaIconAttributes,
  standardBCFormValidationSchema,
  standardBDFormValidationSchema,
  usInputMask
};
